const Pengaturan = [];
/* frontend */
Pengaturan["baseurl"] = "/"; //local
//Pengaturan["baseurl"] = "/billing/"; //Remote

/* API */
//Pengaturan["urlApi"] = "http://localhost/backend-billing/api/"; //local
Pengaturan["urlApi"] = "http://103.114.112.253:8089/api/"; //Remote
export default Pengaturan;
